import React, { useState } from "react";
import noimage from "../../../../assets/Images/no_image_available.jpg";  
import {
  Container,
  Row,
  Col,
  Card,
  Form,
  Button,
  Dropdown,
  Pagination,
  ButtonGroup,
} from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import { IStaffCMSVM, IStoreCmsVM } from "../../../../models/response/IStoreCmsResponse";
import { showAmountWithFormatting } from "../../../../helpers/common-component-helper";

interface IProps {
  staff: IStaffCMSVM;
  storeDetails: IStoreCmsVM;
}


const StoreStaffListSection: React.FC<IProps> = (props) => {
  return (
    <>
      <Col xs={6} sm={6} md={4} lg={6} xl={4} xxl={3}>
        <Card className="mb-3 staff-card">
          <Card.Body>
            <img
              src={props.staff?.Image ? props.staff.Image : noimage}
              alt="Store"
              className="img-fluid staff-image"
            />
            <h3 className="text-center staff-name">{props.staff.StaffName}</h3>
            <p className="mb-1 text-center text-dark">
              {props.staff.Expertise}
            </p>
            <p className="text-muted small">{props.staff.Introduction}</p>

            {props.staff?.IsNominationFee && props.staff.NominationFee > 0 && (
              <>
                <FormattedMessage id="nomination_fee" /> :{" "}
                {showAmountWithFormatting(
                  props.staff.IsNominationFee == true
                    ? props.staff.NominationFee
                    : 0
                )}
              </>
            )}
          </Card.Body>
        </Card>
      </Col>
    </>
  );
};

export default StoreStaffListSection;
